import { Badge, Flex, MantineColor } from '@mantine/core';
import React from 'react';

interface CourseCategoryProps {
  data: any;
  color?: MantineColor;
  noTag?: boolean;
}

const CourseCategory: React.FC<CourseCategoryProps> = ({
  data,
  color,
  noTag
}) => {
  if (!data) return null;

  return (
    <Flex gap={2} wrap={'wrap'}>
      {data.split(',').map((tag, i) => {
        return (
          <Badge key={i} variant="light" color={color || 'blue'}>
            {!noTag && '#'}
            {tag}
          </Badge>
        );
      })}
    </Flex>
  );
};

export default CourseCategory;
